/* eslint-disable */
/* Code generated by generator.ts DO NOT EDIT. */
// Generated: 04-11-2026 08:35:03

export enum Table {
    bvn_basisvaardigheden_norm = "bvn_basisvaardigheden_norm",
    dim_br_brin = "dim_br_brin",
    dim_clc_cijfer_label_conversie = "dim_clc_cijfer_label_conversie",
    dim_ilt_opleidingscode = "dim_ilt_opleidingscode",
    dim_kl_klas = "dim_kl_klas",
    dim_lg_lesgroep = "dim_lg_lesgroep",
    dim_ll_leerling = "dim_ll_leerling",
    dim_mw_medewerker = "dim_mw_medewerker",
    dim_no_norm_onderwijsresultaat = "dim_no_norm_onderwijsresultaat",
    dim_orvs_onderwijsresultaat_vestiging = "dim_orvs_onderwijsresultaat_vestiging",
    dim_ov_onderwijspositie_vergelijkgroep = "dim_ov_onderwijspositie_vergelijkgroep",
    dim_pc_postcode = "dim_pc_postcode",
    dim_per_periode = "dim_per_periode",
    dim_ppv_percentiel_prestatie_vso = "dim_ppv_percentiel_prestatie_vso",
    dim_vk_vak = "dim_vk_vak",
    dim_vs_vestiging = "dim_vs_vestiging",
    dim_vv_vestiging_vak = "dim_vv_vestiging_vak",
    fac_af_afspraak = "fac_af_afspraak",
    fac_aw_aanwezigheid = "fac_aw_aanwezigheid",
    fac_bv_basisvaardigheden = "fac_bv_basisvaardigheden",
    fac_cf_cijfer = "fac_cf_cijfer",
    fac_ck_cijferkolommen = "fac_ck_cijferkolommen",
    fac_ds_doorstroom = "fac_ds_doorstroom",
    fac_ekc_examenkandidaten_en_cijfers = "fac_ekc_examenkandidaten_en_cijfers",
    fac_lb_loopbaan = "fac_lb_loopbaan",
    fac_lr_lesregistratie = "fac_lr_lesregistratie",
    fac_or_onderwijsresultaten = "fac_or_onderwijsresultaten",
    fac_pv_prestatieanalyse_vso = "fac_pv_prestatieanalyse_vso",
    fac_vkk_vakkeuze = "fac_vkk_vakkeuze",
    instelling = "instelling",
    la_leerling_autorisatie = "la_leerling_autorisatie",
    vest_cluster_vso = "vest_cluster_vso"
}
